module.exports = __webpack_public_path__ + "img/logo.fae78557.png";